import React from "react"
import { View, Image, } from "react-native"
import AppTheme from "../../../AppTheme"
import AppStyles from "../../../AppStyles"
import Colors from "../../constants/AppColors"
import PaginationItem from "../Carousel/Pagination"

export const DealCarouselView = (dealData, index, scallingFactor, viewWidth, viewHeight, callback) => {
    const imageUrl = dealData[index]['imageUrl']
    return <View>
        <Image style={{ width: viewWidth, height: viewHeight }}
            source={{ uri: imageUrl }} />
    </View>
}


export const DealsCarouselPagination = (carouselData, progressValue) => {
    return (<View style={[AppStyles.flexRowCenter, AppStyles.mt24, {
        width: AppTheme.appWidth,
    }]}>{carouselData.map((data, index) => {
        return (<PaginationItem key={index} index={index}
            width={8} height={2}
            animValue={progressValue} length={carouselData.length}
            viewStyle={{ backgroundColor: Colors.grey.bg }}
            highlightedViewStyle={{ backgroundColor: Colors.primary }} />)
    })}</View>)
}